import { render, staticRenderFns } from "./AffiliateList.vue?vue&type=template&id=3f81aa82&"
import script from "./AffiliateList.vue?vue&type=script&lang=js&"
export * from "./AffiliateList.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports